import { render, staticRenderFns } from "./FuenteFinanciamientoCapitulos.vue?vue&type=template&id=25689605&"
import script from "./FuenteFinanciamientoCapitulos.vue?vue&type=script&lang=js&"
export * from "./FuenteFinanciamientoCapitulos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports